import { render } from "./TaskForm.vue?vue&type=template&id=59fd02ee&scoped=true"
import script from "./TaskForm.vue?vue&type=script&lang=js"
export * from "./TaskForm.vue?vue&type=script&lang=js"

import "./TaskForm.vue?vue&type=style&index=0&id=59fd02ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fd02ee"]])

export default __exports__